/* import __COLOCATED_TEMPLATE__ from './action-item.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { DASHBOARD_TYPES } from 'sh-www/constants/dashboard';
import { SELLER_ACTION_TYPES } from 'sh-www/models/user-action-item';
import PaymentsOutlineIcon from 'sh-www/components/icons/payments-outline-icon';
import MarkEmailUnreadOutlineIcon from 'sh-www/components/icons/mark-email-unread-outline-icon';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-action-items-module-item';

const applicationRelevantReason = (type, reason, strMatch) => {
  return type === SELLER_ACTION_TYPES.POSTING_LAST_DAY && reason.toLowerCase().includes(strMatch);
}

class ActionItemComponent extends Component {
  @service router;

  get className() {
    return CLASS_NAME;
  }

  get reasonClassNames() {
    const { priority } = this.args;
    return clsx(
      `${CLASS_NAME}__reason`,
      priority <= 100 && 'high',
      (priority > 100 && priority <= 200) && 'medium',
    );
  }

  get applicationInvitedAction() {
    return applicationRelevantReason(this.args.type, this.args.reason, 'invited');
  }

  get applicationSavedAction() {
    return applicationRelevantReason(this.args.type, this.args.reason, 'saved');
  }

  get icon() {
    const { associatedModelName, dashboardType, type } = this.args;

    if (dashboardType === DASHBOARD_TYPES.BUYER) {
      if ('Assignment' === associatedModelName) return 'movie';
      if ('Application' === associatedModelName) return 'content_paste';
    }

    if (dashboardType === DASHBOARD_TYPES.SELLER) {
      if ('Application' === associatedModelName) {
        if (type === SELLER_ACTION_TYPES.APPLICATION_SIGN_CONTRACT || type === SELLER_ACTION_TYPES.APPLICATION_REVIEW_OFFER) {
          return 'pending_actions';
        }
        return 'movie';
      }

      if (type === SELLER_ACTION_TYPES.APPLICATION_SAVED_DEADLINE || this.applicationSavedAction) return 'bookmark';
    }

    return 'radio_button_unchecked';
  }

  get iconSvg() {
    const { associatedModelName, type } = this.args;
    if ('ShInvoice' === associatedModelName || 'ShPayment' === associatedModelName) return PaymentsOutlineIcon;
    if (type === SELLER_ACTION_TYPES.APPLICATION_INVITED_DEADLINE || this.applicationInvitedAction) return MarkEmailUnreadOutlineIcon;

    return null;
  }

  get isNearingLockout() {
    const { daysUntilDelinquent } = this.args;

    if (daysUntilDelinquent == null) {
      return false;
    }

    return daysUntilDelinquent >= 0 && daysUntilDelinquent < 15;
  }

  @action
  navigateToLink() {
    this.router.transitionTo(this.args.path);
  }
}

export default ActionItemComponent;
